import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Img from 'react-bootstrap/Image';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch } from 'react-redux';
import { login as loginApi } from '../services/authService';
import { saveLoginSession, redirectAfterLogin } from '../utils/authStorage';
import { showError, showSuccess } from '../utils/toast';

function Loginpage() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailIsValid, setEmailIsValid] = useState(true);
  const [passwordIsValid, setPasswordIsValid] = useState(true);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const validate = () => {
    const newErrors = {};
    if (!emailPattern.test(email)) newErrors.email = 'Email is Required';
    if (password.length < 6) newErrors.password = 'Password is Required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setEmailIsValid(emailPattern.test(event.target.value));
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordIsValid(event.target.value.length >= 6);
  };

  const loginDatatoSend = async () => {
    setLoading(true);
    try {
      const JSOData = await loginApi(email, password);

      if (JSOData.status === 'Success') {
        if (JSOData.data?.Status === 'InActive') {
          showError('Your account is InActive ❌');
          return;
        }

        dispatch({ type: 'login', data: JSOData.data });
        saveLoginSession(JSOData.data, JSOData.token);
        showSuccess(`Welcome back, ${JSOData.data.EmployeeName || 'User'}`);
        redirectAfterLogin(JSOData.data.UserType);
      } else {
        showError(JSOData.msg || 'Login failed.');
      }
    } catch (error) {
      console.error('Login error:', error);
      showError(error.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      loginDatatoSend();
    } else {
      showError('Invalid Details ❌');
    }
  };

  return (
    <div className="hr-login-page">
      <Form onSubmit={handleSubmit} className="hr-login-card">
        <div className="text-center mb-4">
          <Img src="./Images/LOGO_ORNNOVA.avif" style={{ width: '200px' }} alt="Ornnova logo" />
          <h4 className="mt-3 mb-1">HR Management</h4>
          <p className="text-muted mb-0">Sign in to continue</p>
        </div>
        <hr />
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label><b>Email address</b></Form.Label>
          <Form.Control
            value={email}
            onChange={handleEmailChange}
            style={{ borderColor: errors.email ? 'indianred' : undefined }}
            type="email"
            placeholder="Enter your email address"
          />
          {!emailIsValid && <p className="text-danger mt-2 mb-0">Please enter a valid email address.</p>}
          {errors.email && <p className="text-danger mt-2 mb-0">{errors.email}</p>}
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label><b>Password</b></Form.Label>
          <Form.Control
            value={password}
            onChange={handlePasswordChange}
            style={{ borderColor: errors.password ? 'indianred' : undefined }}
            type="password"
            placeholder="Enter your password"
          />
          {!passwordIsValid && <p className="text-danger mt-2 mb-0">Password must be at least 6 characters long.</p>}
          {errors.password && <p className="text-danger mt-2 mb-0">{errors.password}</p>}
        </Form.Group>

        <div className="text-end mb-3">
          <Link to="/forgotpassword" className="hr-login-link">Forgot password?</Link>
        </div>

        <div className="text-center">
          <Button className="hr-btn-accent px-4" type="submit" disabled={loading}>
            {loading ? 'Signing In...' : 'Sign In'}
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default Loginpage;
